

import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,
      ventas: [],
      pendiente_pago: 0,

      f_c: {
        desde: this.date_rest(this.currentdate(), -15)+"T00:00",
        hasta: this.currentdate()+"T23:59",
        estado: false,
      }

    };
  },

  mounted: function () {



    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      "autoWidth": false,
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      "columnDefs": [
        { className: "dt-right", "targets": [12, 13] },
      ]


    });
    $('.box').boxWidget();

  },


  computed: {
    reporte: function () {
      return (
        "/loteip/cupones?dsis=" + window.sssdi  +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta +
        "&estado=" +
        this.f_c.estado
      );
    }
  },

  methods: {
    consultar() {
      this.loading = true;

      this.tbv.clear();

      this.$http
        .post('/loteip/cupones',this.f_c)
        .then(response => {
          this.ventast_tabla = 0;
          this.pendiente_pago = 0;

          if (response.data.status == 1) {

            for (let i = 0; i < response.data.data.length; i++) {

              if (response.data.data[i][17] == null) {
                this.pendiente_pago += parseFloat(response.data.data[i][15]);
              }
console.log(response.data.data[i][16])
              response.data.data[i][15] = this.num_to_many(parseFloat(response.data.data[i][15]).toFixed(2));
              response.data.data[i][16] = this.num_to_many(parseFloat(response.data.data[i][16]).toFixed(2));

              this.tbv.row.add(response.data.data[i]);

            }

          }


          this.tbv.draw();

          this.loading = false;
        });

    },

  }


};



// WEBPACK FOOTER //
// ./src/components/posintegrado/trxcupones/tventas/tventas.js